var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCtIndividualGreen = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 25,
  viewBox: "0 0 21 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.5001 11.4C11.3524 11.4 12.1701 11.0628 12.7728 10.4627C13.3757 9.86261 13.7144 9.0487 13.7144 8.2C13.7144 7.35131 13.3757 6.53738 12.7728 5.93726C12.1701 5.33714 11.3524 5 10.5001 5C9.64754 5 8.82997 5.33714 8.22717 5.93726C7.62437 6.53738 7.28573 7.35131 7.28573 8.2C7.28573 9.0487 7.62437 9.86261 8.22717 10.4627C8.82997 11.0628 9.64754 11.4 10.5001 11.4ZM3 21C3 20.0195 3.194 19.0485 3.57091 18.1426C3.94782 17.2367 4.50026 16.4136 5.1967 15.7203C5.89315 15.027 6.71995 14.4769 7.62988 14.1018C8.53983 13.7265 9.51511 13.5333 10.5001 13.5333C11.4849 13.5333 12.4602 13.7265 13.3702 14.1018C14.2801 14.4769 15.1068 15.027 15.8033 15.7203C16.4998 16.4136 17.0522 17.2367 17.4291 18.1426C17.806 19.0485 18 20.0195 18 21H3Z",
  fill: "#11BC97"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCtIndividualGreen);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ct-individual-green.39663694f49b498dbf643080d6cddef1.svg";